import styled from 'styled-components'
import { device } from 'constants/media-query'

export const TabContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media ${device.desktop} {
    padding: 12px 12px 12px 12px;
    flex-direction: column;
    min-width: 217px;
    min-height: 396px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 4px 16px 0px rgba(39, 39, 39, 0.1);
  }
`

export const StyledComingSoonSpanConatiner = styled.div`
  width: 43px;
  height: 19px;
  border-radius: 4px;
  background-color: #000000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-inline: 8px;
`
export const StyledComingSoonSpan = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 14.52px;
  color: white;
  font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
`
